import { render, staticRenderFns } from "./PressRoom.vue?vue&type=template&id=5c52aa4c&scoped=true&"
import script from "./PressRoom.vue?vue&type=script&lang=js&"
export * from "./PressRoom.vue?vue&type=script&lang=js&"
import style0 from "./PressRoom.vue?vue&type=style&index=0&id=5c52aa4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c52aa4c",
  null
  
)

export default component.exports